<template>
  <div class="black">
    <NavMenu />
    <Header :init-data="headerData" />
    <Carousel v-if="Object.keys($route.params).length === 0 && $route.params.constructor === Object" />
    <MovingNotice />
    <AppMain />
    <Footer :init-data="footerData" />
  </div>
</template>
<script>
import {Header, NavMenu, Carousel,MovingNotice,AppMain,Footer, } from "./components"
import {getBaseConfig} from "@/api/home"
import {initObject} from "@/utils"

export default {
  components:{
    Header,
    NavMenu,
    Carousel,
    MovingNotice,
    AppMain,
    Footer
  },
  created() {
    this.getBaseData()
  },
  data(){
    return {
      headerData:{
        logo:'',
        tel:'',
        header_logo:''
      },
      footerData:{
        tel:'',
        phone_number:'',
        qq:'',
        email:'',
        address:'',
        icp_record:'',
        copyright:'',
        wechat_qr_img:'',
        logo:''
      }
    }
  },
  methods:{
    getBaseData(){
      getBaseConfig().then((response)=>{
        this.headerData = initObject(this.headerData,response)
        this.footerData = initObject(this.footerData,response)
      })
    }
  }
}
</script>